import cookie from 'cookie'

export function getCookie(name) {
  const value = cookie.parse(document.cookie)[name]
  return value || null
}
